<template>
  <div>
    <div class="formulario">

      <div class="formulario_titulo"> 
        <h2> Gestión de Edificios </h2>
        <hr>
      </div>

      <div class="formulario_cuerpo">
                
        <table class="tabla" v-show="datos.length">
          <thead  >
            <tr class="tabla_cabecera">
              <th class="columnas_cabecera"  v-for="column in columns">
                {{column}}
              </th>
            </tr>
          </thead>
          
          <tbody  class="tabla_cuerpo">
            <tr v-for="(dato,index) in datos">
              <td>{{dato.id_edificio}}</td>
              <td>{{dato.nombre_edificio}}</td>
              <td>{{dato.geometry.coordinates[0]}}</td>
              <td>{{dato.geometry.coordinates[1]}}</td>
              <td>{{dato.descripcion_edificio}}</td>
              <td>{{dato.orientacion_edificio}}</td>

              <td style="width: 10%;">
               
                <div class="botonEditar" @click="edit(index)"></div>
                <div class="botonEliminar" @click="archive(index)"></div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="input-field">
                  <input placeholder="Placeholder" ref="nombreEdificio" v-model="input.nombreEdificio" id="nombreEdificio" type="text">
                  <label for="nombreEdificio">Nombre Edificio</label>
                </div>
              </td>
              <td>
                <div class="input-field">
                  <input placeholder="Placeholder" v-model="input.coordenadaEdificioX" id="coordenadaEdificioX" type="text">
                  <label for="coordenadaEdificioX">Ubicación X </label>
                </div>
              </td>
              <td>
                <div class="input-field">
                  <input placeholder="Placeholder" v-model="input.coordenadaEdificioY" id="coordenadaEdificioY" type="text">
                  <label for="coordenadaEdificioY">Ubicación Y</label>
                </div>
              </td>
              <td>
                <div class="input-field">
                  <input placeholder="Placeholder" v-model="input.descripcionEdificio" id="descripcionEdificio" type="text">
                  <label for="descripcionEdificio">Descripción</label>
                </div>
              </td>
              <td>
                <div class="input-field">
                  <input placeholder="Placeholder" v-model="input.orientacionEdificio" id="orientacionEdificio" type="text">
                  <label for="orientacionEdificio">Orientación</label>
                </div>
              </td>
              <td>
              
                <div class="botonAgregar" @click="add"></div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <div class="formulario_pie"> 
         <router-link class="atras" 
              v-bind:to="'/gestion'">
              <img class="atras" src="../assets/img/atras.svg"/>
        </router-link>
      </div>
    </div>
    
    <div id="modal" class="modal"  v-if="showModal">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3>Actualizar Datos</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
                    <div class="campo">
                      <input placeholder="Nuevo Nombre" id="nombre" type="text" v-model="editInput.nombreEdificio">
                      <label for="last_name">Nombre</label>
                    </div>
                   

                    <div class="campo">
                      <input placeholder="-7.52844" id="edit_ubicacionX" type="text" v-model="editInput.coordenadaEdificioX">
                      <label for="edit_age">Ubicación X</label>
                    </div>
                    <div class="campo">
                      <input placeholder="-1.658874" id="edit_ubicacionY" type="text" v-model="editInput.coordenadaEdificioY">
                      <label for="edit_job">Ubicación Y</label>
                    </div>
                     <div class="campo">
                      <input placeholder="Descripcion" id="descripcion" type="text" v-model="editInput.descripcionEdificio">
                      <label for="first_name">Descripción</label>
                    </div>
                    <div class="campo">
                      <input placeholder="0" id="edit_orientacion" type="text" v-model="editInput.orientacionEdificio">
                      <label for="edit_address">Orientación</label>
                  </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
             
              <button class="modal-default-button" @click="update">
                Editar
              </button>
               <button class="modal-default-button" @click="showModal=false">
                Cancelar
              </button>
            </slot>
          </div>    
          </div> 
        </div>
      </div>
    </div>

    <div id="modal2" class="modal"  v-if="showModal2">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <h3>Actualización de Datos</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
                {{mensaje}}
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              
               <router-link class="atras" 
                v-bind:to="'/gestion/formulario'">
                  <button class="modal-default-button" @click="showModal2=false">
                    OK
                  </button>
               </router-link>
            </slot>
          </div>    
          </div> 
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'

import axios from 'axios'
import store from '../store'

export default {
  name: 'formulario',
  components: {
    cabecera, 
    pie, 
  },
   data() {
    return {
      edificio: '',
      edificioEditado: '',
      datos: [],
      marcadores: [],
      columns: ['Índice', 'Nombre',  'Coordenada X', 'Coordenada Y', 'Descripción', 'Orientación', 'Opciones' ],
      input: {
        idEdificio:0,
        nombreEdificio: "Nuevo Edificio",
        coordenadaEdificioX: -78.6795787720072,
        coordenadaEdificioY: -1.65704039978392,
        descripcionEdificio: "nuevo edificio",
        orientacionEdificio: 0
      },
      editInput: {
        idEdificio:0,
        nombreEdificio: "",
        coordenadaEdificioX:0,
        coordenadaEdificioY: 0,
        descripcionEdificio: "",
        orientacionEdificio: 0
      },
      showModal: false,
      showModal2: false
    }
  },
  methods: {
    consultaApi(opc) {
      this.datos.length = 0;
      //axios.get('http://localhost:3000/api/'+ opc).then((response) => {
      axios.get('http://cimogsys.espoch.edu.ec:3000/api/'+ opc).then((response) => {
        this.datos = response.data.data;
        console.log(this.datos);
      });
    },

    add: function() {
      this.edificio="nombreEdificio="+this.input.nombreEdificio+
                    "&ubicacionEdificioX="+this.input.coordenadaEdificioX+
                    "&ubicacionEdificioY="+this.input.coordenadaEdificioY+
                    "&descripcionEdificio="+this.input.descripcionEdificio+
                    "&orientacionEdificio="+this.input.orientacionEdificio;
      //axios.post('http://localhost:3000/api/newBuilding',this.edificio)
      axios.post('http://cimogsys.espoch.edu.ec:3000/api/newBuilding',this.edificio)
        .then(response => {
          this.showModal2=true;
          if(response=200){
            this.mensaje="Agregado correctamente";
            this.consultaApi("buildings");

          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Ingrese datos correctos";
        })
    },
    //function to handle data edition
    edit: function(index) {
      this.showModal=true;
      this.editInput.idEdificio=this.datos[index].id_edificio;
      this.editInput.nombreEdificio=this.datos[index].nombre_edificio;
      this.editInput.coordenadaEdificioX=this.datos[index].geometry.coordinates[0];
      this.editInput.coordenadaEdificioY=this.datos[index].geometry.coordinates[1];
      this.editInput.descripcionEdificio=this.datos[index].descripcion_edificio;
      this.editInput.orientacionEdificio=this.datos[index].orientacion_edificio;
    },
    //function to update data
    update: function(){
      this.edificioEditado="nombreEdificio="+this.editInput.nombreEdificio+
                    "&ubicacionEdificioX="+this.editInput.coordenadaEdificioX+
                    "&ubicacionEdificioY="+this.editInput.coordenadaEdificioY+
                    "&descripcionEdificio="+this.editInput.descripcionEdificio+
                    "&orientacionEdificio="+this.editInput.orientacionEdificio;
      //axios.put('http://localhost:3000/api/updateEdificio/'+this.editInput.idEdificio,this.edificioEditado)
      axios.put('http://cimogsys.espoch.edu.ec:3000/updateEdificio/'+this.editInput.idEdificio,this.edificioEditado)
        .then(response => {
          console.log(response)
          this.showModal=false;
          this.showModal2=true;
          if(response=200){
            this.mensaje="Editado correctamente";
            this.consultaApi("buildings");

          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Ingrese datos correctos";
        })
    },
     //function to send data to bin
    archive: function(index) {
      console.log(this.datos[index].id_edificio)
      //axios.delete('http://localhost:3000/api/removeEdificio/'+ this.datos[index].id_edificio)
      axios.delete('http://cimogsys.espoch.edu.ec:3000/api/removeEdificio/'+ this.datos[index].id_edificio)
        .then(response => {
          console.log(response)
          this.showModal2=true;
          if(response=200){
            this.mensaje="Eliminado correctamente";
            this.consultaApi("buildings");
          }
        })
        .catch(e => {
          this.showModal2=true;
          this.mensaje="Ocurrió un error. Elimine edificios no relacionados con áreas";
        })
    },

  },
  mounted() {
   
    this.consultaApi("buildings");
    
  }

}

var ordonner = function(a, b) {
  return (a.nombreEdificio > b.nombreEdificio);
};

(function() {
  //initialize modal box with jquery
  ('.modal').modal();
});


</script>

<style  lang="scss"  scoped src="../sass/formulario.scss"></style>



// WEBPACK FOOTER //
// src/components/formulario.vue